import React, { FC, Fragment } from 'react'
import { Divider, Icon, theme, Spacer, MtsDengiButton, useBreakpoint } from '@mtsdengi/ui-kit'
import { Flex, SmartText } from '@mtsdengi/common'
import { TTariffsProps } from '../types'
import { Styled } from './styled'

export const Tariffs: FC<TTariffsProps> = ({ heading, tariffs, button, documents }) => {
  const { isMobile } = useBreakpoint()

  return (
    <Styled.WrapperTariffs>
      <Flex
        mob={{
          flexDirection: 'column',
        }}
        tablet={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <SmartText
          as="h1"
          fontSizeMd={theme.fonts.font_sizes.header.h1}
          fontSizeTablet={theme.fonts.font_sizes.header.lg}
          lineHeightTablet={theme.fonts.line_heights.header.lg}
          lineHeightMd={theme.fonts.line_heights.header.sm}
          fontWeightMob={theme.fonts.font_weights.medium}
          fontSizeMob={theme.fonts.font_sizes.par.p2}
          fontFamily={theme.fonts.font_family_wide}
          color={theme.colors.mtsdengi.text.primary}
        >
          {heading}
        </SmartText>
        <Spacer spacemob={theme.spacings.sm} />
        <MtsDengiButton
          as="a"
          href={button.link}
          target="blunk"
          variant="secondary"
          size={44}
          icon={<Icon icon="baseX24/ic-download" />}
          fluid={isMobile}
        >
          {button.text}
        </MtsDengiButton>
      </Flex>
      {tariffs.map(({ title, grayColor, content, description }) => (
        <Styled.Card isBackgroundColor={grayColor} key={title}>
          <SmartText
            fontSizeMob={theme.fonts.font_sizes.par.xl}
            fontFamily={theme.fonts.font_family_comp}
            fontWeightMob={theme.fonts.font_weights.medium}
            lineHeightMob={theme.fonts.line_heights.par.lg}
            fontSizeTablet={theme.fonts.font_sizes.par.p1}
            lineHeightTablet={theme.fonts.line_heights.par.p2}
            fontSizeMd={theme.fonts.font_sizes.header.lg}
            lineHeightMd={theme.fonts.line_heights.header.lg}
            color={theme.colors.mtsdengi.text.primary}
            marginBottomMob={theme.spacings.sm}
            marginBottomTablet={theme.spacings.md}
            marginBottomMd={42}
          >
            {title}
          </SmartText>
          {!!description && (
            <SmartText
              fontSizeMob={theme.fonts.font_sizes.par.md}
              lineHeightMob={theme.fonts.line_heights.par.md}
              fontSizeTablet={theme.fonts.font_sizes.par.lg}
              lineHeightTablet={theme.fonts.line_heights.par.xl}
              fontFamily={theme.fonts.font_family_comp}
              fontWeightMob={theme.fonts.font_weights.regular}
            >
              {description}
            </SmartText>
          )}
          <Styled.Content>
            {content.map(({ ask, answer }, index) => (
              <Fragment key={ask}>
                <Styled.RowContent>
                  <SmartText
                    fontSizeMob={theme.fonts.font_sizes.par.md}
                    lineHeightMob={theme.fonts.line_heights.par.md}
                    fontSizeTablet={theme.fonts.font_sizes.par.lg}
                    lineHeightTablet={theme.fonts.line_heights.par.lg}
                    fontFamily={theme.fonts.font_family_comp}
                    color={theme.colors.mtsdengi.text.primary}
                  >
                    {ask}
                  </SmartText>
                  <SmartText
                    fontSizeMob={theme.fonts.font_sizes.par.md}
                    fontSizeTablet={theme.fonts.font_sizes.par.lg}
                    lineHeightMob={theme.fonts.line_heights.par.md}
                    lineHeightTablet={theme.fonts.line_heights.par.lg}
                    fontFamily={theme.fonts.font_family_comp}
                    color={theme.colors.mtsdengi.text.primary}
                  >
                    {answer}
                  </SmartText>
                </Styled.RowContent>
                {content[index + 1] !== undefined && <Divider />}
              </Fragment>
            ))}
          </Styled.Content>
        </Styled.Card>
      ))}
      {documents && (
        <Styled.Card isBackgroundColor={false}>
          <SmartText
            fontSizeMob={theme.fonts.font_sizes.par.xl}
            fontFamily={theme.fonts.font_family_comp}
            fontWeightMob={theme.fonts.font_weights.medium}
            lineHeightMob={theme.fonts.line_heights.par.lg}
            fontSizeTablet={theme.fonts.font_sizes.par.p1}
            lineHeightTablet={theme.fonts.line_heights.par.p2}
            fontSizeMd={theme.fonts.font_sizes.header.lg}
            lineHeightMd={theme.fonts.line_heights.header.lg}
            color={theme.colors.mtsdengi.text.primary}
            marginBottomMob={theme.spacings.sm}
            marginBottomTablet={theme.spacings.md}
            marginBottomMd={42}
          >
            {documents.title}
          </SmartText>
          <Styled.Content>
            <Styled.RowContentDocuments>
              <SmartText
                fontSizeMob={theme.fonts.font_sizes.par.md}
                lineHeightMob={theme.fonts.line_heights.par.md}
                fontSizeTablet={theme.fonts.font_sizes.par.lg}
                lineHeightTablet={theme.fonts.line_heights.par.lg}
                fontFamily={theme.fonts.font_family_comp}
                color={theme.colors.mtsdengi.text.primary}
              >
                {documents.subtitle}
              </SmartText>
              <Styled.LinkWrapper>
                {documents.content.map(({ text, link }, index) => (
                  <Styled.Link key={`${index}_${text}`} href={link}>
                    {text}
                  </Styled.Link>
                ))}
              </Styled.LinkWrapper>
            </Styled.RowContentDocuments>
          </Styled.Content>
        </Styled.Card>
      )}
    </Styled.WrapperTariffs>
  )
}
